<template>
    <AddBonCommandeFournisseur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddBonCommandeFournisseur from "@/components/GesCom/BonCommandeFournisseur/AddBonCommandeFournisseur.vue";
  
    export default defineComponent({
      name: "AddBonCommandeFournisseurPage",
      components: {
        
        AddBonCommandeFournisseur,
      },
    });
  </script>